import { FIVE_MINUTES, ONE_DAY } from "./timings";
import { ITerminal, IWebPortalTableData } from "../types/dataInterfaces";
import { ICacheSetting } from "./types";

// This file holds settings for each cache item, representing the initial value, key (upper snake case by convention),
// and the max age in miliseconds that the cache should last for in localStorage, these timings are provided by the timings file.

export const TABLE_DATA_CACHE: ICacheSetting<IWebPortalTableData | null> = {
    initialData: null,
    key: 'TABLE_DATA_CACHE',
    maxAge: FIVE_MINUTES,
};

export const GEO_LOCATION_CACHE: ICacheSetting<IWebPortalTableData | null> = {
    initialData: null,
    key: 'GEO_LOCATION_CACHE',
    maxAge: FIVE_MINUTES,
};
export const AIRPORT_TERMINALS_CACHE: ICacheSetting<ITerminal[]> = {
    initialData: [],
    key: 'AIRPORT_TERMINALS_CACHE',
    maxAge: ONE_DAY
}

export const SEA_PORT_TERMINALS_CACHE: ICacheSetting<ITerminal[]> = {
    initialData: [],
    key: 'SEA_PORT_TERMINALS_CACHE',
    maxAge: ONE_DAY
}